import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(router);

axios.defaults.baseUrl="http://localhost:2001";

Vue.use(VueAxios, axios);

new Vue({
  el: '#app',
  render: h => h(App),
  router
}).$mount('#app');
